import Image, { type StaticImageData } from "next/image";
import { cn } from "@/lib/utils";

/**
 * Caixa de ícone — 86x86 com o ícone de linha laranja de 38px centralizado,
 * como no Figma.
 * Usada nas seções "para quem é" e "como funciona" da FlowFoundation e nas
 * páginas de serviço com `iconVariant: "outline"`. Com `bordered`, a caixa
 * ganha a borda em gradiente (`.icon-box-border`, que também pinta o
 * preenchimento com o mesmo `gray-350/80` — por isso substitui o
 * `bg-gray-350/80` em vez de somar a ele).
 */

type IconBoxProps = React.ComponentPropsWithoutRef<"span"> & {
	icon: StaticImageData;
	bordered?: boolean;
};

export function IconBox({ icon, bordered, className, ...props }: IconBoxProps) {
	return (
		<span
			{...props}
			className={cn(
				"flex size-21.5 shrink-0 items-center justify-center rounded-2xl",
				bordered ? "icon-box-border" : "bg-gray-350/80",
				className,
			)}
		>
			<Image src={icon} alt="" aria-hidden="true" className="size-9.5" />
		</span>
	);
}
